{
  "Mon": "mandag",
  "Tue": "tirsdag",
  "Wed": "onsdag",
  "Thu": "torsdag",
  "Fri": "fredag",
  "Sat": "lørdag",
  "Sun": "søndag",
  "CORE": {
    "notificationDateFormat": "d/M/yy",
    "update": "Loading...",
    "youAreOffline": "Device offline! Connect to a network and try again later!",
    "comeBack": "{{icon}} your skis are waiting for you",
    "help": "Hjælp",
    "notification": {
      "ok": "Forstået"
    },
    "skiHire": "Skileje"
  },
  "ALPINSKIHIRE": {
    "AR": {
      "start": {
        "selectBookingParametersFact3": "Betal i din egen valuta! Alpy.com påtager sig omkostningerne med at veksle din valuta. Kurser opdateres hver dag.",
        "searchHeadline": "Hvor vil du leje dine ski eller dit snowboard?"
      },
      "showTownReserveEarlyEnoughInfo": "Bemærk, at der i løbet af sæsonen kan være mangel på udstyr i butikkerne. Vi anbefaler dig at bestille på forhånd.",
      "shop_filter_distance_to_center": "<strong>Afstand</strong> fra bymidte: <strong><span id='range'>{{ distance }}</span>km</strong>",
      "shopSearch": {
        "formSearchButtonLabel": "SØG",
        "promocode": {
          "couponCodeIsInCart": "Kuponkoden {{ code }} er blevet tilføjet til din kurv og vil være inkluderet, når du går til kassen.",
          "typePromo": "Promovering",
          "typeCoupon": "Kupon"
        }
      }
    },
    "offer": {
      "title": "Derfor med {{ platformname }}"
    },
    "start": {
      "advantagesHeadline": "Du får de bedste priser på skileje, med garanti, når du bestiller online",
      "listedBrands": "Tilgængelige brands",
      "topTowns": "Bedste skiudlejningssteder"
    },
    "sidebar": {
      "hotlineItalic": "Lad os hjælpe dig!",
      "callNow": "Ring nu: ",
      "hotline": "Hotline"
    },
    "shopSearch": {
      "validation": {
        "selectAgeForEveryChild": "Angiv alder for hvert barn (alderen ved begyndelsen af lejen)",
        "onePersonRequired": "vælg mindst en person",
        "enterTown": "Vælg et skiresort."
      },
      "minified": {
        "users": "{{ number_adults }} voksne, {{ number_children }} børn",
        "date": "{{ start_date }} - {{ end_date }}",
        "dateFormat": "EEEEEE d/M/yy"
      },
      "datePickerDisplayFormat": "EEEEEE d/M/yy",
      "datePickerPreviousMessage": "Du kan hente dit udstyr i butikken den <span>{{ date }}</span> efter kl. 15.30. Natskiløb ekskluderet.",
      "datePickerPreviousMessageDateFormat": "d/M/yy",
      "formSearchLabel": "Resort, by, land, butiksnavn",
      "formSearchInfo": "Et øjeblik, vi søger resultater, der matcher din søgning …",
      "formSearchResultDescription": "({{region}}, {{province}})",
      "formSearchResultShopNumber": "{{ count }} Shop(s)",
      "formSearchResultShowAll": "Vis alle {{ count }} resultater",
      "formSearchResultGroupLocations": "By",
      "formSearchResultGroupShops": "Shops",
      "formSearchResultGroupRegions": "Region",
      "formSearchResultGroupCountries": "Land",
      "formSearchButtonLabelDelivery": "Fra {{price}}",
      "deliverToHotel": "Jeg vil have udstyret leveret til min indkvartering – GRATIS!",
      "formStartDate": "1. lejedag",
      "formEndDate": "Sidste lejedag",
      "formNumberOfPeople": "Antal personer",
      "formAdultsLabel": "Voksne",
      "formPeopleCount": {
        "numberOfPeople": "{{ number_adults }} {{ pluralizeAdult }} {{ number_children }} {{ pluralizeChildren }}",
        "adultNone": "voksne",
        "adultSingle": "voksen",
        "adultMultiple": "voksne",
        "childNone": "børn",
        "childSingle": "barn",
        "childMultiple": "børn"
      },
      "formAdultsLabelInfo": "over 18 år ved begyndelsen af ",
      "formChildrenLabel": "Børn",
      "formChildrenLabelInfo": "under 18 år ved begyndelsen af ",
      "formChildInputLabelInfo": "Hvor gammelt er dit barn?/Hvor gamle vil dine børn være ved begyndelsen af ",
      "formChildInputPlaceholder": "hvor gammel?",
      "formPromotionCode": "Kampagnekode",
      "formPromotionCodeNotFound": "Denne kampagnekode findes ikke.",
      "noResults": "Ingen resultater fundet"
    },
    "trustpilot": {
      "dateformat": "d/M/yyyy",
      "score": "TrustScore",
      "reviews": "anmeldelser",
      "reviewsOn": "anmeldelser på"
    },
    "navigation": {
      "skihire": "Skileje",
      "skischool": "Skiskoler",
      "accommodation": "Indkvarteringssteder",
      "aboutUs": "Om os",
      "helpCenter": "Help Center",
      "subnavBooking": "Bestilling",
      "subnavAdditionalOffers": "Yderligere tilbud",
      "subnavGroupBooking": "Gruppebestillinger",
      "subnavTermsAndConditions": "Vilkår og betingelser",
      "subnavBecomePartner": "Bliv partner",
      "subnavPrivacyPolicy": "Privatlivspolitik",
      "subnavHelp": "Kontakt",
      "myAlpinresorts": "Min Alpy.com",
      "subnavLogin": "Log på",
      "subnavLogout": "Log ud",
      "subnavBookingsAndCancellations": "Bookinger og annulleringer",
      "subnavPersonalSettings": "Personlige indstillinger",
      "career": "Karriere",
      "blog": "Blog"
    },
    "geoIp": {
      "chooseACountry": "Vælg et land"
    },
    "topCountries": "Toplande"
  },
  "ALPINSTATIC": {
    "aboutUs": {
      "title": "Om os",
      "metaDescription": "Her finder du alle oplysninger om {{ productName }}-teamet. Stol på Europas største netværk af skiudlejningssteder og skiskoler!"
    },
    "imprint": {
      "title": "Juridiske informationer {{ productName }}",
      "metaDescription": "Aftryk for {{ productName }}"
    },
    "privacy": {
      "title": "Betingelser for beskyttelse af personlige oplysninger for {{ productName }}",
      "metaDescription": "Betingelser for beskyttelse af personlige oplysninger for {{ productName }}"
    },
    "termsAndConditions": {
      "title": "Generelle vilkår og betingelser | {{ productName }}",
      "metaDescription": "Generelle forretningsbetingelser for {{ productName }}"
    },
    "additionalOffers": {
      "title": "Yderligere tilbud"
    }
  },
  "ROUTES": {
    "CHECKOUT": {
      "PAYMENT": "payment",
      "CHECKOUT": "checkout"
    },
    "CANCELLATION": "annullere-booking",
    "SKIHIREENTRY": "skileje",
    "COUNTRIES": "lande",
    "PRODUCTS": "products",
    "PRODUCT": {
      "FINISH": "finish"
    },
    "SKIHIRE": {
      "GROUPS": "groups",
      "PRODUCTS": "products",
      "SEARCH": "sog"
    },
    "SKISCHOOLENTRY": "skiskole",
    "STATIC": {
      "SWISSPASS": "swisspass",
      "IMPRINT": "aftryk",
      "PRIVACYPOLICY": "privatlivspolitik",
      "TERMSANDCONDITIONS": "vilkar",
      "HELP": "hjaelp",
      "ABOUTUS": "om-oss",
      "ADDITIONALOFFERS": "yderligere-tilbud",
      "HOWTO": "sadan-gor-du"
    }
  }
}